"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _form = require("@clayui/form");

var _react = _interopRequireDefault(require("react"));

var _Context = require("./Context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ClayAutocompleteInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _React$useContext = _react.default.useContext(_Context.LegacyContext),
      loading = _React$useContext.loading;

  return /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, props, {
    insetAfter: loading,
    ref: ref
  }));
});

ClayAutocompleteInput.displayName = 'ClayAutocompleteInput';
var _default = ClayAutocompleteInput;
exports.default = _default;